var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logout_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.098,
    height: 15.098,
    viewBox: "0 0 15.098 15.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout_1_",
    "data-name": "logout (1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33158",
    "data-name": "Path 33158",
    d: "M7.524,15.948H1.881A1.886,1.886,0,0,1,0,14.061V2.737A1.886,1.886,0,0,1,1.881.85H7.524a.629.629,0,0,1,0,1.258H1.881a.629.629,0,0,0-.627.629V14.061a.629.629,0,0,0,.627.629H7.524a.629.629,0,0,1,0,1.258Z",
    transform: "translate(0 -0.85)",
    fill: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33159",
    "data-name": "Path 33159",
    d: "M178.251,236h-7.524a.629.629,0,0,1,0-1.258h7.524a.629.629,0,0,1,0,1.258Z",
    transform: "translate(-165.084 -227.818)",
    fill: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33160",
    "data-name": "Path 33160",
    d: "M340.821,115.955a.629.629,0,0,1-.44-1.077l3.359-3.327-3.359-3.327a.631.631,0,0,1-.006-.89.625.625,0,0,1,.887-.006l3.812,3.775a.63.63,0,0,1,0,.9l-3.812,3.774A.623.623,0,0,1,340.821,115.955Z",
    transform: "translate(-330.162 -104.002)",
    fill: "#dfdfdf"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.5958cf164d2ff038f77d426942737ab7.svg";
export { ForwardRef as ReactComponent };